import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";
import { BreadcrumbServiceService } from "../../services/breadcrumb-service.service";

@Component({
  selector: "app-lottery-participant-details",
  templateUrl: "./lottery-participant-details.component.html",
  styleUrls: ["./lottery-participant-details.component.css"],
})
export class LotteryParticipantDetailsComponent implements OnInit {
  participantId: string = "";
  loading: boolean = false;

  participation: any = null;
  user: any = null;
  order: any = null;
  lottery: any = null;
  store: any = null;
  payment: any = null;

  constructor(
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbServiceService,
  ) {
    this.participantId = this.route.snapshot.paramMap.get("id") || "";
  }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.loading = true;
    const url = ConfigApi.URLS.LOTTERY_PARTICIPATION.DETAILS + `/${this.participantId}`;

    this.apiCallingService.callAPI({}, "GET", url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.participation = res.data?.participation || null;
          this.user = res.data?.user || null;
          this.order = res.data?.order || null;
          this.lottery = res.data?.lottery || null;
          this.store = res.data?.store || null;
          this.payment = res.data?.payment || null;
          if (this.lottery?._id) {
            this.breadcrumbService.updateBreadcrumbs([
              { title: "Home", url: "user/dashboard" },
              { title: "Lottery", url: "/user/lottery" },
              { title: "Participants", url: `/user/lottery-participants/${this.lottery._id}` },
              { title: "Details", url: "" },
            ]);
          }
        }
        this.loading = false;
      },
      (error) => {
        console.error(error);
        this.toastr.error("Failed to load participant details");
        this.loading = false;
      },
    );
  }

  goBack() {
    if (this.lottery?._id) {
      this.router.navigate(["/user/lottery-participants", this.lottery._id]);
    } else {
      this.router.navigate(["/user/lottery"]);
    }
  }
}
